import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { CommonApiService } from '@app/services/common-api.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  userId = '';
  loginid = '';
  password = '';
  error = '';

  constructor(private authService: AuthService, private router: Router, private common: CommonApiService) { }

  login() {
    // debugger;
    this.authService.login(this.loginid, this.password).subscribe({
      next: (res: unknown) => {
        console.log(res);
        const r = res as Record<string, unknown>;
        const token = r['Data'];
        console.log('JWT Token:', token);
        if (typeof token === 'string' && token.length > 0) {
          const user = r['user'];
          console.log(user);

          localStorage.setItem('authToken', token);

          // Optionally decode it to get role or username
          const payload = JSON.parse(atob(token.split('.')[1]));
          console.log('Decoded Payload:', payload);
          this.common.userInfo = payload;

          if (res && payload.user_type && payload.user_status === 'A') {
            this.authService.setUser(payload.userID);
            this.redirectUser(payload.user_type);
          } else {
            this.error = 'Invalid user or inactive status.';
          }
        }
      },
      error: () => {
        this.error = 'Login failed. Check credentials.';
      }
    });
  }

  redirectUser(role: string) {
    if (role === 'admin') this.router.navigate(['/admin']);
    else if (role === 'designer') this.router.navigate(['/designer']);
    else if (role === 'creator') this.router.navigate(['/creator']);
    else if (role === 'SME') this.router.navigate(['/SME/chat']);
    else this.error = 'Unauthorized user role.';
  }
}
